import { createContext } from "react";

export const DisplayContext = createContext()